export function CloseIcon() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.1659 5.1057C5.873 4.81281 5.39813 4.81281 5.10524 5.1057C4.81234 5.3986 4.81234 5.87347 5.10524 6.16636L10.9389 12L5.10523 17.8336C4.81233 18.1265 4.81233 18.6014 5.10523 18.8943C5.39812 19.1872 5.87299 19.1872 6.16589 18.8943L11.9995 13.0607L17.8332 18.8943C18.1261 19.1872 18.6009 19.1872 18.8938 18.8943C19.1867 18.6014 19.1867 18.1265 18.8938 17.8336L13.0602 12L18.8938 6.16637C19.1867 5.87348 19.1867 5.3986 18.8938 5.10571C18.6009 4.81282 18.126 4.81282 17.8331 5.10571L11.9995 10.9393L6.1659 5.1057Z'
        fill='#EAEEF9'
      />
    </svg>
  )
}
